import { george, pr, NetbankingAPI, theme } from "aaa";

import { ui } from "components/util/uiHelpers";

import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { useState } from "react";
import { IConsent } from "types/profile";
import { NetbankingAPIClient } from "network/APIClient";
import { SigningComponent } from "components/signing/views/SigningComponent";
import { ISigningInfo } from "types/signing";
import { pushRoute } from "stores/RouterFunctions";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

import { mobileSummaryStyle, summaryStyle, summaryElementLabelStyle } from "../styles";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";

type Props = {
    approval: boolean;
    consents?: IConsent[];
    onSuccess: () => void;
};

export const TradingPreferencesMarketingApproval = (
    { approval, consents = [], onSuccess }: Props
) => {
    const [marketingConsent, setMarketingConsent] = useState(consents.find(consent => consent.type === "MARKETING")?.status === "AGREE")
    const [signingInfo, setSigningInfo] = useState<ISigningInfo | undefined>(undefined);

    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const summaryElementStyles = isMobile
        ? mobileSummaryStyle
        : summaryStyle;

    const toggleConsent = () => {
        setMarketingConsent((prev) => !prev);
    }

    const submit = async () => {
        try {
            const marketingConsent = consents.find(consent => consent.type === "MARKETING");
            if (marketingConsent) {
                marketingConsent.status = "AGREE";
                const target = NetbankingAPI.putDataConsent({ consents });
                const response = await NetbankingAPIClient.requestType(target);
                setSigningInfo(response.signInfo)
            }
        } catch (error) {
            pushRoute("/error");
        }
    }

    const closeSigning = () => setSigningInfo(undefined);

    const handleSuccess = () => {
        setSigningInfo(undefined);
        onSuccess();
    }


    if (approval) {
        return null;
    }

    if (signingInfo) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 100,
                }}
            >
                <div
                    style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        position: "relative",
                        maxWidth: theme.MAX_APP_WIDTH,
                        height: "100vh",
                        background: "white"
                    }}
                >
                    <SigningComponent
                        signingInfo={signingInfo}
                        content={
                            <div style={{ padding: 32 }}>
                                <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                                    {ui.__("tradingPreferences.marketingInfo.summary.title")}
                                </pr.P_18_TITLE>
                                <div style={{ marginTop: 8 }}>
                                    <george.ResponsiveSummaryElement
                                        label={ui.__("tradingPreferences.marketingInfo.summary.label")}
                                        style={summaryElementLabelStyle}
                                        {...summaryElementStyles}
                                    >
                                        <pr.SigningLabel>
                                            {ui.__("tradingPreferences.marketingInfo.summary.value")}
                                        </pr.SigningLabel>
                                    </george.ResponsiveSummaryElement>
                                </div>
                            </div>
                        }
                        onClose={closeSigning}
                        onRetry={submit}
                        onSuccess={handleSuccess}
                    />
                </div>
            </div>
        );
    }

    return (
        <pr.A11yPopupHider>
            <div style={{ display: "flex", flexDirection: "column", gap: 32, padding: 32 }}>
                <george.ApprovalEmbedded
                    defaultChecked={approval}
                    hideTitle
                    message={
                        <>
                            <pr.P_16_TITLE
                                style={{
                                    fontWeight: 600,
                                    color: ui.isDarkMode ? "white" : "#0A285C",
                                    paddingBottom: 8,
                                }}
                            >
                                {ui.__("tradingPreferences.overview.marketingInformation.headline")}
                            </pr.P_16_TITLE>
                            <pr.P_16_CONTENT
                                style={{
                                    color: ui.isDarkMode ? "white" : "#0A285C"
                                }}
                            >
                                <FormattedHTMLMessage id="tradingPreferences.overview.marketingInformation.description" />
                            </pr.P_16_CONTENT>
                        </>
                    }
                    onCheck={toggleConsent}
                />
                <div style={{ textAlign: "center" }}>
                    <GdsFakeActionButton
                        className="custom-trading-preferences-gds-button"
                        color="primary"
                        disabled={!marketingConsent}
                        fullWidth={isMobile}
                        onClick={submit}
                    >
                        {ui.__("tradingPreferences.overview.marketingInformation.agree")}
                    </GdsFakeActionButton>
                </div>
            </div>
            <pr.LightSeparatorLine />
        </pr.A11yPopupHider>
    );
}


// WEBPACK FOOTER //
// ./src/components/tradingPreferences/components/TradingPreferencesMarketingApproval.tsx